// Module
var code = "<template> <require from=\"../../resources/elements/full-calendar\"></require> <article if.bind=\"usersList.length > 0\" id=\"EmployeeCalendar__wrapper\"> <full-calendar editable.bind=\"true\" calendar-options.bind=\"calendarOptions\" containerless></full-calendar> </article> </template> ";
// Exports
export default code;